export const SET_FUNDING_COST = 'SET_FUNDING_COST';
